import { render, staticRenderFns } from "./CategoryListComponent.vue?vue&type=template&id=0f2e55f2"
import script from "./CategoryListComponent.vue?vue&type=script&lang=js"
export * from "./CategoryListComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports